<template>
    <q-layout view="hHh lpR fFf" style="height: 100vh">
        <q-page-container
            class="fit row wrap justify-center items-center content-center"
        >
            <q-card bordered style="width: 600px">
                <img
                    src="../assets/d_tr1.png"
                    style="width: 300px; height: 300px; margin: auto"
                />

                <q-card-section>
                    <q-input
                        outlined
                        v-model="dob"
                        mask="date"
                        label="Select DOB"
                    >
                        <template v-slot:append>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy
                                    cover
                                    transition-show="scale"
                                    transition-hide="scale"
                                >
                                    <q-date v-model="dob">
                                        <div
                                            class="row items-center justify-end"
                                        >
                                            <q-btn
                                                v-close-popup
                                                label="Close"
                                                color="primary"
                                                flat
                                            />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                    <q-input
                        v-model="email"
                        label="Email"
                        outlined
                        type="email"
                        style="width: 100%; margin-top: 10px"
                    ></q-input>
                    <q-input
                        v-model="mobileNumber"
                        label="Mobile Number"
                        outlined
                        style="width: 100%; margin-top: 10px"
                    ></q-input>

                    <q-input
                        v-model="password"
                        label="Password"
                        outlined
                        type="password"
                        style="width: 100%; margin-top: 10px"
                    ></q-input>

                </q-card-section>

                <q-separator></q-separator>

                <q-card-actions>
                    <q-btn
                        label="Register"
                        color="indigo"
                        style="width: 120px"
                        @click="register"
                    ></q-btn>

                    <q-btn
                        label="Back"
                        color="indigo"
                        style="width: 120px"
                        href="#/login"
                    ></q-btn>
                </q-card-actions>
            </q-card>
        </q-page-container>
    </q-layout>
</template>

<script>
import axios from "axios";
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { Notify } from "quasar";

export default {
    setup() {
        const mobileNumber = ref();
        const email = ref();
        const dob = ref();
        const password = ref();

        const router = useRouter();
        const register = async () => {
            try {
                const { data } = await axios.post(
                    "https://cycles.nlf.clinic/ws-nlp/public/pt-service/register-user",
                    {
                        phone: mobileNumber.value,
                        email: email.value,
                        birthDate: dob.value,
                        password: password.value,
                    }
                );
                Notify.create({
                    type: "positive",
                    message: "Registration Successful",
                });
            } catch (err) {
                if (err.response.status == 404) {
                    Notify.create({
                        type: "negative",
                        message: err.response.data.message,
                    });
                }

                if (err.response.status == 409) {
                    Notify.create({
                        type: "negative",
                        message: err.response.data.message,
                    });
                }

                if (err.response.status == 500) {
                    Notify.create({
                        type: "negative",
                        message: "Some error occured",
                    });
                }
            }
        };

        return {
            mobileNumber,
            email,
            dob,
            password,
            register,
        };
    },
};
</script>

<style scoped>
.q-layout {
    background-image: url(../assets/d_nl.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
